import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box, SxProps, Theme } from '@mui/material';
import { FRAGMENT_CARD_PADDING_X } from '../constants';
import { FragmentCardCreator } from './FragmentCardCreator';
import { FragmentCardRelativeTime } from './FragmentCardRelativeTime';
import { FragmentCardTags } from './FragmentCardTags';

const footerSx = {
  px: FRAGMENT_CARD_PADDING_X,
  pb: 1.5,
  pt: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  // Allow the truncateable meta group to shrink inside narrow grid cards.
  minWidth: 0,
} as const;

const metaGroupSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  minWidth: 0,
  flex: 1,
  overflow: 'hidden',
} as const;

/**
 * Shared footer for fragment cards: creator label, relative creation time,
 * and optional tag icon that shows tags in a popover on hover.
 * Keeps a single row on narrow cards by truncating the meta group and
 * pinning the tag icon on the right.
 */
export function FragmentCardFooter({
  fragment,
  sx,
}: {
  fragment: FragmentListItemDto;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={{ ...footerSx, ...sx }}>
      <Box sx={metaGroupSx}>
        <FragmentCardCreator creator={fragment.creator} />
        <FragmentCardRelativeTime createdAt={fragment.createdAt} sx={{ flexShrink: 0 }} />
      </Box>
      <FragmentCardTags tags={fragment.tags as unknown as string[]} />
    </Box>
  );
}
